/* tslint:disable */

/**
 */
export class AutoTest {
    ID_AUTO?: number;
    ID_STUDY?: number;
    DATE?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/auto-test.ts